document.addEventListener("DOMContentLoaded", () => {
  const observer = new MutationObserver(() => {
    // Only run when buttons exist
    const buttons = document.querySelectorAll("input.sr-only");
    if (buttons.length > 0) {
      buttons.forEach((btn) => {
        if (!btn.dataset.listenerAdded) {
          btn.addEventListener("change", () => {
            safeUpdatePerDay();
          });
          btn.dataset.listenerAdded = "true";
        }
      });

      // Initial run
      safeUpdatePerDay();
    }
  });
  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
  function safeUpdatePerDay() {
    const activeOption = document.querySelector(
      ".appstle_subscription_wrapper_option.appstle-active-option"
    );
    if (!activeOption) return;

    const priceElement = activeOption.querySelector(
      ".appstle_subscription_amount"
    );
    if (!priceElement) return;

    const text = priceElement.textContent.trim();
    const num = parseFloat(text.replace("£", ""));
    if (isNaN(num)) return;

    const perDay = (num / 30).toFixed(2);
    console.log(`Active option per day: £${perDay}`);

    // Disconnect observer temporarily to prevent infinite loops
    observer.disconnect();

    // Check if per-day element exists
    let perDayDiv = activeOption.querySelector(".per-day-display");
    if (!perDayDiv) {
      perDayDiv = document.createElement("div");
      perDayDiv.className = "per-day-display";
      perDayDiv.style.fontSize = "0.9em";
      perDayDiv.style.color = "#555";
      perDayDiv.style.marginTop = "4px";
      activeOption.appendChild(perDayDiv);
    }

    // Update content safely
    perDayDiv.textContent = `£${perDay}/day`;

    // Reconnect observer
    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }

  wdsSetUpsellData();
  document.addEventListener("change", function (e) {
    const select = e.target.closest(".lb-variant-picker");
    if (!select) return;
    const card = select.closest(".lb-product-card");
    const subQty = Number(card.getAttribute("data-subscription-qty"));
    setTimeout(function () {
      wdsSetUpsellProductData(card, subQty);
    }, 100);
  });
  document.addEventListener(
    "click",
    function (e) {
      const btn = e.target.closest(".lb-button");
      if (!btn) return;
      e.stopImmediatePropagation();
      e.preventDefault();
      const cardProduct = btn.closest(".lb-product-card");
      const items = [
        {
          id: cardProduct.getAttribute("lb-variant-id"),
          quantity: 1,
          selling_plan: cardProduct.getAttribute("data-selling-plan"),
        },
      ];
      fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({ items }),
      })
        .then((res) => res.json())
        .then((data) => {
          wdsSetUpsellData();
          if (document.querySelector(".shopify-section--main-cart")) {
            window.location.href = "/cart";
          } else {
            document.dispatchEvent(new CustomEvent("cart:refresh"));
          }
        })
        .catch((err) => console.error("Error:", err));
    },
    true
  );
  document.addEventListener("cart:change", function (e) {
    wdsAddedGift();
  });
});

async function wdsGetCart() {
  const result = await fetch("/cart.js");
  return await result.json();
}
async function wdsSetUpsellData() {
  const cart = await wdsGetCart();
  let subQty = 0;
  cart.items.forEach((item) => {
    if (item.selling_plan_allocation) {
      subQty++;
    }
  });
  if (subQty > 1) {
    subQty = 2;
  }
  const observer = new MutationObserver(() => {
    const upsellProducts = document.querySelectorAll(".lb-product-card");
    if (upsellProducts.length > 0) {
      upsellProducts.forEach((item) => {
        item.setAttribute("data-subscription-qty", subQty);
        wdsSetUpsellProductData(item, subQty);
      });
      observer.disconnect();
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
}
async function wdsAddedGift() {
  const cart = await wdsGetCart();
  let notGift = true;
  let subscripiton = false;
  let giftKey = "";
  if (cart.item_count === 0) return;
  cart.items.forEach((item) => {
    if (item.id === 52008776237397) {
      giftKey = item.key;
      notGift = false;
    }
    if (item.id !== 52008776204629 && item.selling_plan_allocation) {
      subscripiton = true;
    }
  });
  if (notGift && subscripiton) {
    const items = [
      {
        id: 52008776237397,
        quantity: 1,
      },
    ];
    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({
        items,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        document.dispatchEvent(new CustomEvent("cart:refresh"));
      })
      .catch((err) => console.error("Error:", err));
  } else if (!notGift && !subscripiton) {
    fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        id: giftKey,
        quantity: 0,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        document.dispatchEvent(new CustomEvent("cart:refresh"));
      })
      .catch((err) => console.error("Error:", err));
  }
}
function wdsSetUpsellProductData(cardProduct, subQty) {
  const variantId = cardProduct.getAttribute("lb-variant-id");
  fetch(`/variants/${variantId}.js`)
    .then((r) => r.json())
    .then((variant) => {
      if (variant.selling_plan_allocations) {
        const oldLabel = cardProduct.querySelector(".lb-sale-badge");
        if (oldLabel) {
          oldLabel.remove();
        }
        const price = "£" + (variant.selling_plan_allocations[subQty].price / 3000).toFixed(2) + '/day';
        const sale = ((variant.selling_plan_allocations[subQty].compare_at_price - variant.selling_plan_allocations[subQty].price) / 100).toFixed(2);
        const saleLabel = document.createElement("div");
        saleLabel.className = "lb-sale-badge";
        saleLabel.textContent = "Save £" + sale;
        cardProduct.setAttribute("data-selling-plan", variant.selling_plan_allocations[subQty].selling_plan_id);
        cardProduct.querySelector(".lb-price-sale-price").textContent = price;
        cardProduct.appendChild(saleLabel.cloneNode(true));
      }
    });
}
